<ng-scrollbar
	(reachedBottom)="onBottomReached()"
	class="absolute w-full h-full"
	track="vertical"
	visibility="hover"
>
	<div class="flex flex-col p-6 xl:px-28 space-y-6">
		<spr-coachee-profile-information></spr-coachee-profile-information>
		<p-tabView
			[activeIndex]="controller.activeTabIndex$ | async"
			(activeIndexChange)="onActiveIndexChange($event)"
			class="flex-auto h-full overflow-hidden block"
			styleClass="flex flex-col h-full space-y-3"
		>
			<p-tabPanel
				[header]="controller.i18n + '.notesTabPanel.header' | translate"
				headerStyleClass="uppercase"
			>
				<spr-coachee-profile-notes></spr-coachee-profile-notes>
			</p-tabPanel>
			<p-tabPanel
				[header]="controller.i18n + '.documentsTabPanel.header' | translate"
				headerStyleClass="uppercase"
			>
				<spr-coachee-profile-documents></spr-coachee-profile-documents>
			</p-tabPanel>
			<p-tabPanel
				[header]="controller.i18n + '.meetingsTabPanel.header' | translate"
				headerStyleClass="uppercase"
			>
				<spr-coachee-profile-meetings></spr-coachee-profile-meetings>
			</p-tabPanel>
		</p-tabView>
	</div>
</ng-scrollbar>
